<template lang="pug">
  button(@click="$emit('toggle', !hidden)")
    Icon(:name="hidden ? 'eye-closed' : 'eye-opened'" pointer)
</template>

<script>
export default {
  name: 'BtnEye',
  props: {
    hidden: Boolean,
  },
};
</script>

<style scoped lang="scss">
  button {
    width: 21px;
    height: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: .5;
    border: 1px solid #92A0B0;
    border-radius: 4px;
    transition: opacity .1s linear;
    background: transparent;
    cursor: pointer;

    &:not([disabled]):hover {
      opacity: 1;
    }

    &.expanded svg {
      transform: rotate(180deg);
    }
  }
</style>
